import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';
import { Any } from 'json2typescript';

@JsonObject('model.time_card.TotalByProject')
export class TotalByProject extends AbstractModel {

	@JsonProperty(String, 'name')
	name?: string;

	@JsonProperty(Number, 'total')
	total?: number;

}
